import { ClientConfigProductName } from '@frontend/vanilla/core';

export const BannerWidgetLoader = {
    id: 'banner',
    loaderFn: () => import('./banner-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
